module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.5014568.ttf";